import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import {
  CustomModal,
  getModifiedScrollHeight,
} from "../../../../utils/UtilFunctions";
import { useNavigate } from "react-router";

import { Title } from "../../../../stories/Title/Title";
import Input from "../../../../stories/Input/Input";
import {
  empType,
  LicenseTypes,
  Operation,
  PageFor,
  TableHeaders,
} from "../../../../utils/Enum.types";
import {
  debouncedDelay,
  EMPTY_STRING,
  emptyFunc,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../utils/constants";
import { Button } from "../../../../stories/Button/Button";
import Edit from "../../../../images/EditProfile.svg";
import {
  GridAlignment,
  GridColDef,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";

import useAssetTableJson from "../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../utils/types";
import { useLazyQuery } from "@apollo/client";
import { GetEmp } from "./queries/queries";

import {
  EmpMasterEdge,
  EmpMasterOrderField,
  EmpQueryType,
  GetEmpResult,
  GetEmpVars,
} from "./queries/types";
// import { modalOpertaionFlag } from "../Index";
import { AddModalStyles } from "../../../../styles/CustomModalStyles";
import AddUsers from "./AddUser";

import useUrlParams from "../../../../customHooks/useUrlParams";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../context/context";
import { payloadTypes } from "../../../../context/reducer";
import {
  HEADER_TEXT_ALIGN,
  MARKS_TEXT_ALIGN,
  TABLE_ROW_HEIGHT,
} from "../../../../styles/Variables";
import { StyledDatagrid } from "../../../../styles/DatagridStyles";
import Navbar from "../../../common/layout/Navbar";
import LoadingModal from "../../../pages/LoadingModal";
import { modalOpertaionFlag } from "../../customer/Index";
import ImportUsers from "./ImportUsers";
import { useHotKey } from "../../../../utils/hotKeys";
import CompanySelect from "../../../../customComponents/CompanySelect";
import SubsidiarySelect from "../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../customComponents/SiteSelect";
import EmpTypeSelect from "../../../../customComponents/EmpTypeSelect";
import Close from "../../../../images/Close.svg";
import { useDebounce } from "../../../../customHooks/useDebounce";

export interface ModalType {
  operation: Operation;
  id: number;
  flag: boolean;
}

interface Props {
  setModalFlag: (value: React.SetStateAction<boolean>) => void;
  modalFlag: boolean;
}
const UsersList = ({ setModalFlag, modalFlag }: Props) => {
  const navigate = useNavigate();
  const { Users } = useAssetTableJson();

  const { state, dispatch } = useContext(AppContext);
  const { customer_id, company_id } = useUrlParams();
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [employees, setEmployees] = useState<EmpMasterEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [importModal, setImportModal] = useState(false);
  const [selectedEmpType, setSelectedEmpType] = useState("");
  const [empQueryType, setEmpQueryType] = useState(EmpQueryType.ALL);

  const [addModal, setAddModal] = useState<modalOpertaionFlag>({
    operation: Operation.CREATE,
    flag: false,
  });

  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);

  useHotKey({
    handleFunc: () => {
      setAddModal({
        flag: true,
        operation: Operation.CREATE,
      });
    },
    charater: "a",
    specialCharacter: "ctrlKey",
  });
  const [GetEmployees, { data, loading, fetchMore }] = useLazyQuery<
    GetEmpResult,
    GetEmpVars
  >(GetEmp);
  const dynamicHeaders: TableHeaderProps[] = Users.List.map((header) => ({
    headerName: header.headerName,
    className: header.cellClassName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
  }));
  const columns: GridColDef[] = [
    ...dynamicHeaders,
    {
      field: "actions",
      cellClassName: "td-actions-print ",
      headerClassName: "td-actions-print-header",
      headerAlign: HEADER_TEXT_ALIGN,
      align: MARKS_TEXT_ALIGN,
      headerName: TableHeaders.ACTION,
      renderCell: (params) => {
        return (
          <>
            <img
              src={Edit}
              alt="/"
              onClick={() => {
                dispatch({
                  type: payloadTypes.SET_EMP_ID,
                  payload: {
                    empId: params.row.user_id,
                  },
                });
                setAddModal({
                  operation: Operation.UPDATE,
                  flag: true,
                });
              }}
            />
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetEmp.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newEmp) => {
          const filteredStudent = employees.find(
            (employee) => employee.node.id === newEmp.node.id
          );
          if (filteredStudent) {
            return {
              ...newEmp,
              node: {
                ...newEmp.node,
              },
            };
          }
          return newEmp;
        });
        setEmployees(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            name: node.name,
            mobile: node.mobile,
            email: node.email,
            user_type: node.empType,
            user_id: node.id,
            customerName: node.customer.name,
            company: node.company.name,
            subsidiary: node.subsidiary.name,
            site: node.site.name,
          }))
        );
      } else {
        setEmployees(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            name: node.name,
            mobile: node.mobile,
            email: node.email,
            user_type: node.empType,
            user_id: node.id,
            customerName: node.customer.name,
            company: node.company.name,
            subsidiary: node.subsidiary.name,
            site: node.site.name,
          }))
        );
      }
      setEndCursor(data.GetEmp.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetEmp.edges;
              const pageInfo = fetchMoreResult.GetEmp.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetEmp.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetEmp: {
                  edges: [...employees, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetEmp.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    if (customer_id) {
      GetEmployees({
        variables: {
          after: null,
          customer_id,
          first: ROWS_PER_PAGE,
          input: {
            queryType: empQueryType,
            empType: selectedEmpType
              ? [selectedEmpType as empType]
              : [empType.DCP],
            companyID: state.companyId ? state.companyId : 0,
            ldgrID: 0,
            siteID: state.subSiteId ? state.subSiteId : 0,
            subsidiaryID: state.subsidiaryId ? state.subsidiaryId : 0,
          },
          orderBy: {
            direction: OrderDirection.ASC,
            field: EmpMasterOrderField.NAME,
          },

          name: debouncedSearch,
        },
      });
    }
  }, [
    customer_id,
    GetEmployees,
    debouncedSearch,
    state.companyId,
    state.subSiteId,
    state.subsidiaryId,
    selectedEmpType,
  ]);

  return (
    <>
      {!modalFlag ? <Navbar NavType={LicenseTypes.CUSTOMER_USERS} /> : ""}

      <div className="cust_users__title">
        <Title>{rows ? rows[0]?.customerName : "Customer Users"}</Title>
        {modalFlag && (
          <>
            <img src={Close} alt="" onClick={() => setModalFlag(false)} />
          </>
        )}
      </div>

      <div className={`cust_users${!modalFlag ? "" : "--modal"}`}>
        <div className="row g-0 cust_users--filters">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search ..."
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchData(e.target.value)
              }
            />
          </div>
          <div className="col-2">
            <CompanySelect
              label="Company Name"
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_COMPANY_ID,
                    payload: {
                      companyId: newValue.value,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_COMPANY_ID,
                    payload: {
                      companyId: 0,
                    },
                  });
                }
              }}
              onKeyDown={() => {}}
              value={state.companyId ? state.companyId : 0}
            />
          </div>
          <div className="col-2">
            <SubsidiarySelect
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_SUB_ID,
                    payload: {
                      subsidiaryId: newValue.node.id,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_SUB_ID,
                    payload: {
                      subsidiaryId: 0,
                    },
                  });
                }
              }}
              label={"Subsidiary"}
              companyID={state.companyId ? state.companyId : 0}
              onKeyDown={emptyFunc}
              value={state.subsidiaryId ? state.subsidiaryId : 0}
            />
          </div>
          <div className="col-2">
            <SiteSelect
              label="Site Name"
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: newValue.value,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: 0,
                    },
                  });
                }
              }}
              companyId={state.companyId ? state.companyId : 0}
              subsidiaryId={state.subsidiaryId ? state.subsidiaryId : 0}
              onKeyDown={() => {}}
              value={state.subSiteId ? state.subSiteId : 0}
            />
          </div>
          <div className="col-2">
            <EmpTypeSelect
              value={selectedEmpType}
              onChange={(newValue) => {
                if (newValue) {
                  setEmpQueryType(EmpQueryType.BY_TYPE);
                  setSelectedEmpType(newValue as empType);
                } else {
                  setEmpQueryType(EmpQueryType.ALL);
                  setSelectedEmpType("");
                }
              }}
              label="Type"
            />
          </div>
          {!modalFlag ? (
            <div className="col flex-end">
              <Button
                mode="addnew"
                autoFocus
                onClick={() => {
                  setAddModal({
                    flag: true,
                    operation: Operation.CREATE,
                  });
                }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="cust_users__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            hideFooter
            onCellClick={(params) => {
              if (params.field === "name" && modalFlag) {
                dispatch({
                  type: payloadTypes.SET_EMP_ID,
                  payload: {
                    empId: params.row.user_id,
                  },
                });
                setModalFlag(false);
              }
            }}
          />
        </div>
        <div className="row ">
          <div className="col-2">
            {!modalFlag ? (
              <Button
                type="button"
                onClick={() => {
                  setImportModal(!importModal);
                }}
                mode="excel"
              >
                Import Users
              </Button>
            ) : (
              ""
            )}

            <Button
              mode={modalFlag ? "cancel" : "back"}
              onClick={() => (modalFlag ? setModalFlag(false) : navigate(-1))}
            />
          </div>

          <div className="col flex-end">
            <div className="overall-total-count">
              Total Users : <b>{data?.GetEmp.totalCount}</b>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={addModal.flag} style={AddModalStyles} ariaHideApp={false}>
        <AddUsers setModalFlag={setAddModal} operation={addModal.operation} />
      </Modal>
      <CustomModal
        isOpen={importModal}
        onRequestClose={() => setImportModal(!importModal)}
        contentComponent={
          <ImportUsers
            setModalFlag={setImportModal}
            pageType={PageFor.MODAL}
            NavType={LicenseTypes.COMPANY}
          />
        }
        style={AddModalStyles}
      />
      <LoadingModal flag={!searchData && loading} />
    </>
  );
};

export default UsersList;
